module.exports = __webpack_public_path__ + "media/images/flags/32/Poland-71ba67fdceac7335846a42efe5a73a1e.png";